<template>
  <div class="l-container container">
    <div>
      <div class="step">
        <Step :currentStep="1" :steps="steps" />
      </div>
      <div class="title">
        <h1>補助クーポン利用申請</h1>
      </div>
    </div>
    <a-divider />
    <div class="box">
      <div class="box-content">
         <div>
          <Item :data="dataItemOrder" />
        </div>
        <div>
          <SectionContentTitle
            lineType="v-line"
            titleContent="お申し込み内容"
          />
          <div class="menu-content1 relative pb-3">
            <div
              
              class="items-content"
            >
              <div class="item-content gap-3">
                <p>宿泊期間</p>
                <span class="mr-2">{{customerPlan ? customerPlan.stayDayJP : ''}}</span>
                <span class="mr-2">{{customerPlan ? customerPlan.stayNights : ''}} 泊</span>
                <span class="mr-2">{{customerPlan ? customerPlan.stayRooms : ''}} 部屋</span>
                <span class="mr-2">（大人{{totalAdultPeople | formatInteger}}名/子ども{{totalChildren | formatInteger}}名）</span>
              </div>
              <div class="item-content gap-3">
                <p>チェックイン</p>
                <span class="mr-2">{{checkinTime}}:00</span>
              </div>
            </div>
            <div class="totalPrice absolute right-0 top-5">
              <span class="text1 pr-3 pt-2">合計</span> 
              <span class="text2"> {{ totalFee | formatCurrency}} </span>
            </div>
          </div>
        </div>
        <a-divider />
        <div class="menu-content2 pt-4">
          <SectionContentTitle
            lineType="v-line"
            titleContent="申込者情報"
          />

          <!-- <div class="item-content pb-4">
            <p style="min-width: 150px" class="title-coupon">補助クーポンA</p>
            <span>適用条件：本人同行</span>
          </div>
          <div class="content">
            <table class="table-common">
              <tr class="label-inp">
                <td class="flex style-l pt-5">
                  <div class="label-l">数量</div>
                  <div class="ml-4 category">
                    必須
                  </div>
                </td>
                <td class="data">
                  <div class="class-collapse py-0">
                    <div class="mt-3 font-16">所持クーポン：{{totalCoupon}}枚</div>
                    <div class="item-collapse">
                    <a-collapse :expand-icon-position="expandIconPosition" :bordered="false">
                      <a-collapse-panel key="1" header="利用できるクーポンの種類">
                        <div class="content grid grid-cols-1">
                          下記の適用対象者ごとに1泊1枚ずつご利用いただけます。<br>
                          <div class="" v-for="item in dataCoupon" :key="item">
                            <span v-if="item.usageType == 0">本人大人</span>
                            <span v-if="item.usageType == 1">家族子ども</span>
                            <span v-if="item.usageType == 2">家族大人</span>
                            <span> {{item.couponDiscount}} 円（適用期間 {{item.startDate}}〜{{item.endDate}}）</span>
                          </div>  
                        </div>
                      </a-collapse-panel>
                    </a-collapse>
                    </div>
                  </div>
                  <a-divider />
                  <div class="radio-content pt-3 font-16">
                    <a-radio-group v-model="valueGift" @change="handleChangeGift">
                      <a-radio class="font-16" :value="0">
                        クーポンを最大限利用する
                      </a-radio>
                      <a-radio class="font-16" :value="1">
                        一部のクーポンを利用する
                      </a-radio>
                      <a-radio class="font-16" :value="2">
                        利用しない
                      </a-radio>
                    </a-radio-group>
                  </div>
                  <div :class="valueGift === 2 ? 'hidden' : 'block'">
                    <div class="flex justify-between mt-4">
                      <div class="flex">
                        <span class="w-full self-center mr-2 font-16" style="min-width:90px">利用枚数</span>
                        <span class="w-full font-16" v-if="valueGift === 0">{{totalCoupon}}枚</span>
                        <a-select v-if="valueGift === 1" v-model="valueNumberPapers" @change="getSelected($event)" :options="options" />
                      </div>
                      <span v-if="valueGift !=1" class="font-bold self-center value-2">{{SumAllGift()}} 円分</span>
                      <span class="font-bold self-center" :class="valueGift === 1 ? 'block' : 'hidden'">{{ totalSelectedCoupon }} 円分</span>
                    </div>
                    <div class="flex mt-4">
                      <span>利用するクーポンの内訳</span>
                    </div>
                    <div :class="valueGift === 0 ? 'block' : 'hidden'"  class="flex justify-between mt-2" v-for="item in dataCoupon" :key="item">
                      <div class="" >
                        <span v-if="item.usageType == 0">本人大人</span>
                        <span v-if="item.usageType == 1">家族子ども</span>
                        <span v-if="item.usageType == 2">家族大人</span>
                        {{item.couponDiscount}}
                        円（適用期間 {{item.startDate}}〜{{item.endDate}}） ✕ {{ item.remaining}}     
                      </div>
                      <div>
                        <span>{{item.couponValue * item.remaining}} 円分</span>
                      </div>
                    </div>
                    <div v-for="item in dataCoupon" :key="item">
                      <div :class="valueGift === 1 ? 'block' : 'hidden'"  class="flex justify-between mt-2" v-if="item.couponId <= selectedCoupon">
                        <div class=""  >
                          <span v-if="item.usageType == 0">本人大人</span>
                          <span v-if="item.usageType == 1">家族子ども</span>
                          <span v-if="item.usageType == 2">家族大人</span>
                          {{item.couponDiscount}}
                          円（適用期間 {{item.startDate}}〜{{item.endDate}}） ✕ {{ item.remaining}}     
                        </div>
                        <div>
                          <span>{{item.couponDiscount * item.remaining}} 円分</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="label-inp">
                <td class="flex style-l pt-5">
                  <div class="label-l">クーポン適用対象者</div>
                  <div class="ml-4 category">
                    必須
                  </div>
                </td>
                <td class="data">
                  <div class="items-data mt-0">
                    <div class="label-data">申込者</div>
                  </div>
                  <div class="items-data">
                    <div class="label-data">性別</div>
                    <div class="content-data">
                      男性
                    </div>
                  </div>
                  <div class="items-data">
                    <div class="label-data">氏名</div>
                    <div class="content-data">
                      ベネフィット 太郎
                    </div>
                  </div>
                  <div class="items-data pb-2">
                    <div class="label-data">年齢</div>
                    <div class="content-data">
                      <div class="flex">
                        <a-select class="mw-select" v-model="value" :options="options" />
                        <span class="self-center">歳</span>
                      </div>
                    </div>
                  </div>
                  <a-divider />
                  <div class="items-data">
                    <div class="label-data">性別</div>
                    <div class="content-data">
                      男性
                    </div>
                  </div>
                  <div class="items-data">
                    <div class="label-data">氏名（カタカナ）</div>
                    <div class="content-data input-items">
                      <div class="flex mt-3 gap-2">
                        <a-input placeholder="セイ" />
                        <a-input placeholder="セイ" />
                      </div>
                    </div>
                  </div>
                  <div class="items-data">
                    <div class="label-data">会員との続柄</div>
                    <div class="content-data">
                      <div class="flex">
                        <a-select class="mw-select" v-model="value" :options="options" />
                      </div>
                    </div>
                  </div>
                  <div class="items-data pb-2">
                    <div class="label-data">年齢</div>
                    <div class="content-data">
                      <div class="flex">
                        <a-select class="mw-select" v-model="value" :options="options" />
                        <span class="self-center">歳</span>
                      </div>
                    </div>
                  </div>
                  <a-divider />
                  <div class="items-data">
                    <div class="label-data">性別</div>
                    <div class="content-data">
                      男性
                    </div>
                  </div>
                  <div class="items-data">
                    <div class="label-data">氏名（カタカナ）</div>
                    <div class="content-data input-items">
                      <div class="flex mt-3 gap-2">
                        <a-input placeholder="セイ" />
                        <a-input placeholder="セイ" />
                      </div>
                    </div>
                  </div>
                  <div class="items-data">
                    <div class="label-data">会員との続柄</div>
                    <div class="content-data">
                      <div class="flex">
                        <a-select class="mw-select" v-model="value" :options="options" />
                      </div>
                    </div>
                  </div>
                  <div class="items-data">
                    <div class="label-data">年齢</div>
                    <div class="content-data">
                      <div class="flex">
                        <a-select class="mw-select" v-model="value" :options="options" />
                        <span class="self-center">歳</span>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="label-inp" />
            </table>
          </div> -->


          <div class="item-content pb-4 pt-4">
            <!-- <p style="min-width: 150px">補助クーポンB</p> -->
            <p class="title-coupon" style="min-width: 250px">ベネフィット・ワン補助金</p>
            <span>適用条件：大人</span>
          </div>
          <div class="content">
            <table class="table-common">
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="label-l">数量</div>
                  <div class="ml-4 category">
                    必須
                  </div>
                </td>
                <td class="data">
                  <div class="items-data mt-0 font-16">
                    所持クーポン：1枚{{eachCouponValue}}円 ✕ 10枚
                  </div>
                  <div class="items-data">
                    <div class="radio-content pb-4">
                      <a-radio-group v-model="couponOption" :defaultValue="couponOption">
                        <a-radio class="font-16" :value="0">
                          クーポンを最大限利用する
                        </a-radio>
                        <a-radio class="font-16" :value="1">
                          一部のクーポンを利用する
                        </a-radio>
                        <a-radio class="font-16" :value="2">
                          利用しない
                        </a-radio>
                      </a-radio-group>
                    </div>
                  </div>
                  <a-divider />
                  <div>
                    <div class="flex justify-between mt-4">
                      <div class="flex">
                        <span class="w-full self-center mr-2 font-16" style="min-width:90px">利用枚数</span>
                        <a-select v-model="selectCoupon"
                                  :options="optionsB"
                                  :disabled="couponOption === 0 || couponOption === 2"/>
                      </div>
                      <span class="font-bold value-2 self-center">{{ couponDiscount | formatCurrency}} 分</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="label-inp" />
            </table>
          </div>
        </div>
        <a-divider />
        <div class="total-payment pt-5 pb-10">
          <div>
            <span class="label-amount">宿泊料合計①</span>
            <span class="value-1" >{{ totalFee | formatCurrency }}</span>
          </div>
          <div>
            <span class="label-amount">補助クーポン利用申請額②</span>
            <span class="value-1">{{ couponDiscount | formatCurrency }}</span>
          </div>
          <div class="pt-3">
            <span class="label-amount">決済金額（① - ②）</span>
            <span class="value-1">{{ totalFee - couponDiscount | formatCurrency }}</span>
          </div>
        </div>
        <div class="buttons flex gap-2 justify-center mt-4 mb-4">
          <button @click="handleBack()" class="c-btn btn-white">
            <span class="">戻る</span>
          </button>
          <button @click="handleNext()" class="c-btn btn-grey">
            <span class="">次へ</span>
          </button>
        </div>
      </div>
    </div>
    <div class="items">
      <div class="item">
        <p>プライバシーポリシー</p>
        <i class="icon icon-bor-arrow-right " />
      </div>
      <div class="item">
        <p>お問合せ</p>
        <i class="icon icon-bor-arrow-right " />
      </div>
      <div class="item">
        <p>お申し込みの注意点</p>
        <i class="icon icon-bor-arrow-right " />
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable quote-props */
import _ from 'lodash'
import { COUPON_SELECT_OPTIONS } from '@/constants/coupon'
import { Step, Item, SectionContentTitle } from '@/components/compound'
import { GET_ITEM_DETAIL, GET_COUPON_DETAIL, SAVE_DATA_BS_APP_02_004 } from '@/store/modules/bs_app/actions'

export default {
  components: {
    Step,
    Item,
    SectionContentTitle
  },
  data() {
    return {
      eachCouponValue: 7000,
      couponOption: 0,
      selectCoupon: null,
      couponDiscount: 0,
      checkinTime: '00',
      expandIconPosition: 'right',
      valueGift: 0,
      valueCoupon: 0,
      selectedCoupon: null,
      totalSelectedCoupon: null,
      totalCoupon: null,
      totalCouponActive: null,
      valueCouponB: null,
      totalValueCouponB: '5000',
      totalCost: 0,
      value_time_picker: '00',
      info_lives: '',
      night: '',
      dataItemOrderImage: {},
      menuNo: null,
      imageUrl: null,
      dataItemOrder: {},
      value: null,
      valueNumberPapers: '0枚',
      options: COUPON_SELECT_OPTIONS,
      valueNumberPapersB: '10枚',
      optionsBValue: null,
      optionsB: COUPON_SELECT_OPTIONS,
      fee1: 5000,
      fee2: 1000,
      totalFee: 0,
      useBenepoPoint: '',
      AllGiftCart: [],
      dataCoupon: {},
      titleContent: ['お申し込み内容', '申込者情報'],
      lineType: { horizontal: 'h-line', vertical: 'v-line' },
      steps: [
        { id: 1, label: '申請内容を入力' },
        { id: 2, label: '申込確認' },
        { id: 3, label: '申込完了'}
      ],
      itemContent: [
        { items: '宿泊期間', content: '2021/12/31から2泊', quantity: '1部屋' },
        { items: 'チェックイン時間', content: '14:00' }
      ],
      UsedGiftCart: [
        { title: '本人 大人 5000円（適用期間 2021/10/01〜2022/03/31）', quantity: '２', value: '6,000円分' },
        { title: '家族 子ども 1500円（適用期間 2021/10/01〜2022/12/31）', quantity: '1', value: '1,500円分'}
      ],
      totalAdultPeople: 0,
      totalChildren: 0,
      customerPlan: null
    }
  },
  mounted() {
    this.useBenepoPoint = !!this.$store.getters.isUseBenepoPoint
    this.getPlanBasicInfo()
    this.mountData()
    this.customerPlan = this.getCustomerPlan
    this.getItemDetail()
    // this.getGiftCart()
    this.getCouponDetail()
    this.getInfoLive()
    if (!this.bsApp02004) {
      this.couponOption = 0
      this.selectCoupon = 10
    }
  },
  computed: {
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
    },
    getCustomerPlan() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.customerPlan', null))
    },
    bsApp02004() {
      return _.cloneDeep(_.get(this.$store.state, 'bs_app.bs_app.bs_app_02_004', null))
    },
    bsApp02001() {
      return _.cloneDeep(_.get(this.$store.state, 'bs_app.bs_app.bs_app_02_001', null))
    }
  },
  watch: {
    couponOption(val) {
      if (val === 0) {
        this.selectCoupon = 10
      } else if (val === 2) {
        this.selectCoupon = 0
      } else if (val === 1 && this.selectCoupon === 0) {
        this.selectCoupon = 10
      }
    },
    selectCoupon(val) {
      if (this.totalFee !== null && val * this.eachCouponValue > this.totalFee) {
        this.couponOption = 1
        this.couponDiscount = this.totalFee
      } else {
        this.couponDiscount = this.selectCoupon * this.eachCouponValue
      }
      this.autoSelectCouponBaseValue(this.couponDiscount)
    }
  },
  methods: {
    mountData() {      
      const bsApp02001 = this.bsApp02001
      if(bsApp02001) {
        this.checkinTime = bsApp02001.checkinTime
        this.totalFee = bsApp02001.totalFee ? bsApp02001.totalFee : 0
        this.totalAdultPeople = bsApp02001.totalAdultPeople
        this.totalChildren = bsApp02001.totalChildren
      }
      const bsApp02004 = this.bsApp02004
      if(bsApp02004) {
        this.couponOption = bsApp02004.couponOption
        this.selectCoupon = bsApp02004.selectCoupon
        this.couponDiscount = bsApp02004.couponDiscount
      }
    },
    getCouponDetail() {
      this.$store.dispatch(GET_COUPON_DETAIL).then((data) => {
        this.dataCoupon = data.coupon
      })
    },
    getItemDetail() {
      this.$store.dispatch(GET_ITEM_DETAIL).then((data) => {
        if (data !== null) {
          this.itemContent = data.itemContent
        }
        this.itemContent[0].content = this.info_lives.time
        this.itemContent[0].quantity = `${this.info_lives.rooms  }部屋`
        this.itemContent[0].night = `から${this.info_lives.nights }泊 `
        this.itemContent[1].content = `${this.checkinTime}:00`
      })
    },
    SumAllGift() {
      const SumAllGift = this.dataCoupon.map(item => (item.couponValue * item.remaining))
      return SumAllGift.reduce((a, b) => a + b, 0)
    },
    autoSelectCouponBaseValue(couponDiscount) {
      this.selectCoupon = Math.ceil(+couponDiscount / this.eachCouponValue)
    },
    handleBack() {
      const bs_app_02_004 = {
        couponOption: this.couponOption,
        selectCoupon: this.selectCoupon,
        couponDiscount: this.couponDiscount,
        amount: this.totalFee - this.couponDiscount
      }
      this.$store.dispatch(SAVE_DATA_BS_APP_02_004, bs_app_02_004).then(() => {})
      this.$router.go(-1)
    },
    handleNext() {
      const query = this.$route.query
      const bs_app_02_004 = {
        couponOption: this.couponOption,
        selectCoupon: this.selectCoupon,
        couponDiscount: this.couponDiscount,
        amount: this.totalFee - this.couponDiscount
      }
      this.$store.dispatch(SAVE_DATA_BS_APP_02_004, bs_app_02_004).then(() => {})
      if(this.useBenepoPoint) {
        this.$router.push({path: '/register-benepo', query})
      } else {
        this.$router.push({path: '/register-confirmation', query})
      }
    },
    getInfoLive() {
      const info_live = this.getCustomerPlan
      const info_lives = {
        time: info_live.stayDay,
        nights: info_live.stayNights,
        rooms: info_live.stayRooms,
        stayAdults: info_live.stayAdults,
        countTotalChildren: info_live.countTotalChildren
      }
      this.numberOfRooms = info_lives.rooms
      this.info_lives = info_lives
    },
    getPlanBasicInfo() {
      const planBasicInfo = this.getPlanInfo ? this.getPlanInfo.planBasicInfo : null
      const roomBasicInfo = this.getPlanInfo ? this.getPlanInfo.roomBasicInfo : null
      if(planBasicInfo && roomBasicInfo) {
        this.dataItemOrder = {
          type: 'type-small',
          menu_id: _.get(planBasicInfo, 'menuNo', ''),
          label: _.get(this.getPlanInfo, 'menuInformation.categoryInfomation', ''),
          baseImg: _.get(planBasicInfo, 'planImages[0].imageUrl', ''),
          title1: _.get(this.getPlanInfo, 'menuInformation.menuNm', ''),
          title2: _.get(planBasicInfo, 'planNm', '')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>